<div class="grey-back">
  <div class="desktop-view-header ontario-row ontario-padding-top-16-!">
    <!-- Stepper -->
    <div class="steps-container ontario-column inline-block ontario-padding-left-0-!">
      <div class="table-row">
        <div class="step-div" [class.active-step]="activeStep == 1">
          <div class="step-text" [class.ontario-border-highlight--blue]="activeStep == 1">
            <div class="text-container">{{ (isSoseMode ? 'EmployerPortal.SoseNewApplicationEnterApplicantInformation' : 'ApplicationForNewTrainingProgram.EnterApplicantInformation') | translate}}
            </div>
          </div>
        </div>

        <div class="step-div" [class.active-step]="activeStep == 2">
          <div class="step-text" [class.ontario-border-highlight--blue]="activeStep == 2">
            <div class="text-container">{{ (isSoseMode ? 'EmployerPortal.SoseNewApplicationAuditorInformation' : 'ApplicationForNewTrainingProgram.TrainingProviderAttestation') | translate}}
            </div>
          </div>
        </div>

        <div class="step-div" [class.active-step]="activeStep == 3">
          <div class="step-text" [class.ontario-border-highlight--blue]="activeStep == 3">
            <div class="text-container">{{ (isSoseMode ? 'EmployerPortal.SoseNewApplicationDocumentAndAttestation' : 'ApplicationForNewTrainingProgram.TrainingProgramMaterial') | translate}}</div>
          </div>
        </div>

        <div class="step-div" [class.active-step]="activeStep == 4">
          <div class="step-text last" [class.ontario-border-highlight--blue]="activeStep == 4">
            <div class="text-container">{{ (isSoseMode ? 'EmployerPortal.SoseNewApplicationPreviewAndCertification' : 'ApplicationForNewTrainingProgram.PreviewAndSubmit') | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="login-container ontario-column inline-block"> 
    </div>
  </div>
  <div class="mobile-view-header ontario-row ontario-padding-top-16-!">
    <div class="steps-container ontario-column inline-block ontario-padding-left-0-!">
      <span>Step {{activeStep.toString()}} of 4</span>
    </div>
    <div class="login-container ontario-column inline-block"> 
    </div>
  </div>
</div>
